import { gql } from '@apollo/client';

export const MUTATION = gql`
  mutation CreateFormFieldDefinition(
    $organization_id: Int!
    $label: String!
    $name: String!
    $prefill: Boolean
    $locked: Boolean
    $required_default: Boolean
    $type: String!
    $target: String
    $group: String
    $order: Int!
    $options: [String]
    $active: Boolean
    $multiselect: Boolean
    $helpText: String
  ) {
    createFormFieldDefinition(
      organization_id: $organization_id
      input: {
        active: $active
        label: $label
        name: $name
        prefill: $prefill
        locked: $locked
        required_default: $required_default
        type: $type
        target: $target
        group: $group
        order: $order
        options: $options
        multiselect: $multiselect
        helpText: $helpText
      }
    ) {
      active
      group
      id
      label
      locked
      name
      options
      order
      organization_id
      prefill
      required_default
      target
      type
      multiselect
      helpText
    }
  }
`;
